<template>
  <div id="app">
    <!-- 头部轮播 -->
    <div class="head">
      <swiper :options="swiperOption">
        <!-- <swiper-slide>
          <img
            src="./assets/image/banner1.png"
            style="max-width: 100%; width: 100%"
          />
        </swiper-slide> -->
        <swiper-slide>
          <img
            src="./assets/image/banner2.jpg"
            style="max-width: 100%; width: 100%;"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 表单 -->
    <div class="form">
      <div class="form-item">
        <div class="label">礼卡编码</div>
        <div class="input">
          <input type="text" v-model="key" placeholder="请输入礼卡编码" />
        </div>
      </div>
      <div class="form-item">
        <div class="label">礼卡密码</div>
        <div class="input">
          <input type="password" v-model="value" placeholder="请输入礼卡密码" />
        </div>
      </div>
      <div class="form-item">
        <drag-verify
          :width="311"
          ref="dragVerify"
          :isPassing.sync="isPassing"
          text="请按住滑块拖动"
          successText="验证通过"
          handlerBg="rgb(250,250,250)"
          handlerIcon="el-icon-arrow-right"
          successIcon="el-icon-circle-check"
        ></drag-verify>
      </div>
      <div class="form-item">
        <el-button :type="btnType" :disabled="isDisabled" @click="submit">
          申请提货
        </el-button>
      </div>
      <div class="form-item">
        <el-button type="primary" @click="queryStatus">
          查询礼卡状态
        </el-button>
      </div>
    </div>
    <!-- 底部公告 -->
    <div class="notice">
      <h3>提货公告</h3>
      <div class="content">
        <p v-for="(item, i) in noticeList" :key="i">
          {{ item.no + '、' + item.text }}
        </p>
        <p style="text-align: right;">苏州庭蟹汇电子商务有限公司</p>
      </div>
    </div>
    <!-- 提交信息 -->
    <div class="submitInfo" :class="{ show: verify }" v-if="verify">
      <div class="title">收货地址</div>
      <div class="info">
        <div class="form">
          <div class="form-item">
            <div class="label">收货人姓名</div>
            <div class="input">
              <input
                type="text"
                v-model="name"
                placeholder="请输入收货人姓名"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="label">收货人手机号</div>
            <div class="input">
              <input
                type="text"
                v-model="phone"
                placeholder="请输入收货人手机号"
              />
            </div>
          </div>
          <div class="form-item">
            <div class="label">收货地址</div>
            <div class="input">
              <input type="text" v-model="address" placeholder="收货地址" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">发货日期</div>
            <div class="input">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                v-model="wantTime"
              ></el-date-picker>
            </div>
          </div>

          <div class="form-item">
            <el-button type="info" @click="verify = false">退出</el-button>
            <el-button type="success" @click="showDialog">提交地址</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 提交提示 -->
    <el-dialog title="提示" width="300px" :visible.sync="dialogVisible">
      <span>确定提交此地址吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="pushDddress">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 物流提示 -->
    <el-dialog title="物流信息" width="300px" :visible.sync="wuliuVisible">
      <span>{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wuliuVisible = false">关 闭</el-button>
        <el-button type="primary" @click="copy">复制</el-button>
      </span>
    </el-dialog>
    <!-- 系统暂停提示 -->
    <el-dialog title="公告/通知：" width="300px" :visible.sync="stopVisible">
      <div style="line-height: 1.3; font-weight: bold;">
        <div>尊敬的客户，您好：</div>
        <span>{{ stopMessage }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {
  checkCode,
  fillIn,
  text,
  buttonStatus,
  queryStatusByCardKey,
} from './network'

export default {
  name: 'App',
  data() {
    return {
      // 公告列表
      noticeList: [],
      // 验证表单
      key: '',
      value: '',
      isPassing: false,
      verify: false,
      // 收货表单
      id: '',
      name: '',
      phone: '',
      address: '',
      wantTime: '',
      // 提示框
      dialogVisible: false,
      // 物流提示
      msg: '',
      wuliuVisible: false,
      // 轮播图
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: {
          delay: 2000,
        },
        loop: true,
      },
      // 提示
      stopVisible: false,
      stopMessage: '',
      // 按钮
      isDisabled: true,
      btnType: 'info',
    }
  },
  created() {
    // 底部文本
    text().then((res) => {
      this.noticeList = res.result.sort((a, b) => +a.no - +b.no)
    })
    // 系统设置
    buttonStatus().then((res) => {
      // 系统提示
      this.stopVisible = res.result.detailStatus != 2
      this.stopMessage = res.result.detail
      // 按钮
      this.isDisabled = res.result.buttonStatus == 2
      this.btnType = res.result.buttonStatus != 2 ? 'danger' : 'info'
    })
  },
  methods: {
    // 复制文本
    copy() {
      this.$copyText(this.msg).then(
        (e) => {
          this.$message.success('复制成功')
        },
        (e) => {
          this.$message.warning('浏览器不支持')
        },
      )
    },
    // 查询礼卡
    queryStatus() {
      if (!this.isPassing) {
        this.$message.warning('请通过滑块验证')
        return
      }

      if (!this.key) {
        this.$message.warning('请输入礼品编码')
        return
      }

      queryStatusByCardKey({
        cardKey: this.key,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.result);
          } else {
            this.$message.warning(res.result)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
    // 验证会员卡
    submit() {
      if (!this.isPassing) {
        this.$message.warning('请通过滑块验证')
        return
      }
      checkCode({
        key: this.key,
        value: this.value,
      })
        .then((res) => {
          if (res.code === 200) {
            this.verify = true
            this.id = res.result
          } else if (res.code === 2000) {
            this.msg = res.result
            this.wuliuVisible = true
          } else {
            this.$message.warning(res.result)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    showDialog() {
      if (!this.name) {
        this.$message.warning('请输入名称')
        return
      }
      if (!this.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.address) {
        this.$message.warning('请输入地址信息')
        return
      }
      if (!this.wantTime) {
        this.$message.warning('请选择发货日期')
        return
      }
      this.dialogVisible = true
    },
    // 地址
    pushDddress() {
      fillIn({
        lipinId: this.id,
        name: this.name,
        phone: this.phone,
        address: this.address,
        wantTime: this.wantTime,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('兑换成功')
          } else {
            this.$message.warning(res.result)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      this.dialogVisible = false
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: { directive },
  },
}
</script>

<style lang="less">
@import 'assets/reset.css';

#app {
  width: 100%;
  min-width: 320px;
  max-width: 640px;
  margin: 0 auto;
}

.swiper-slide {
  width: 100%;
}

.el-dialog__body {
  padding: 0px 20px 20px !important;
}

.form {
  padding: 8vw;

  button {
    width: 100%;
  }

  .form-item {
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:nth-of-type(2) {
      margin-bottom: 22px;
    }

    &:last-of-type {
      margin-top: 22px;
      margin-bottom: 0;
    }

    .label {
      flex-shrink: 0;
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
    }

    .input {
      height: 48px;
      line-height: 48px;
      flex-grow: 1;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
      padding-left: 20px;

      input {
        font-size: 1rem;
        border: none;
        width: 100%;
        outline: none;
      }
    }
  }
}

.notice {
  padding: 0 2rem 2rem;
  h3 {
    margin-bottom: 10px;
    font-size: 1.2rem;
    color: #f53033;
    font-weight: bold;
  }
  p {
    color: #666;
    font-size: 0.9rem;
  }
  .content {
    text-align: justify;
    text-justify: distribute-all-lines;
    line-height: 1.8;
  }
}

.submitInfo {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: -100vw;
  background-color: #fff;
  z-index: 1;
  transition: all 0.8s ease-in;
  &.show {
    left: 0;
  }

  .title {
    margin-top: 3rem;
    font-size: 1rem;
    text-align: center;
  }
}
</style>
